// eslint-disable-next-line
import {injectable} from "inversify";
import {rootContainer, TYPE} from "../container/root";
import {IApiResponse, IHttpService} from "../http-service";
import {IAccountModel} from "../../models/Account";
import {IManagerCredentials} from "../../manager-approval-modal/manager-credentials-stores";

export interface ICheckManagerCredentials {
    success: boolean,
}

@injectable()
class ManagersApprovalService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async fetchManagers(): Promise<IAccountModel[]> {
        const res = await this.httpService.get<IApiResponse<IAccountModel[]>>(`/rms-api/managers-list`);
        return res.payload;
    }

    public async sendManagersCredentials(data: IManagerCredentials): Promise<ICheckManagerCredentials> {
        const res = await  this.httpService.post<IApiResponse<ICheckManagerCredentials>>(`/rms-api/validate-manager-password`, data)
        return res.payload;
    }

}


export default ManagersApprovalService;
